import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebSidenavContentListComponent } from './web-sidenav-content-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModuleWeb } from '../material/material.module';
import { WebWidgetPropertyFormsModule } from '../widgetPropertyForms/web-widget-property-forms.module';
import { GridsterModule } from '@hyperviewhq/angular2gridster';




@NgModule({
  declarations: [
    WebSidenavContentListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,  
    MaterialModuleWeb,
    ReactiveFormsModule,
    DragDropModule,
    WebWidgetPropertyFormsModule,
    GridsterModule.forRoot()
  ],
  exports: [
    WebSidenavContentListComponent
  ]
})
export class SidenavContentListModule { }
